import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --rose-image-height: calc(167rem / var(--default-rem-px-count));
    }

    .rose-layout {
      max-width: 100%;
      width: 100%;
    }

    /* No-header variant: padding / images / padding. */
    .rose-layout.exclude-header {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    /* Header variant adds header and description rows above the strip. */
    .rose-layout.include-header {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .include-header > .header {
      grid-row: 2;
      grid-column: 2 / 8;
      padding-bottom: calc(var(--text-stack-header-gap) - var(--block-row-gap));
    }

    .include-header > .description {
      grid-row: 3;
      grid-column: 2 / 8;
    }

    .exclude-header > .images {
      grid-row: 2;
    }

    .include-header > .images {
      grid-row: 4;
    }

    .images {
      /* Bleeds through the right outer-padding track; overflow scrolls. */
      grid-column: 2 / 9;
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      min-width: 0;
    }

    .images > .image {
      padding-right: var(--between-column-padding-lg);
    }

    .image-wrapper > img {
      margin-bottom: calc(16rem / var(--default-rem-px-count));
      height: var(--rose-image-height);
    }

    /* The hairline belongs to image-caption; a bare tag selector from out
       here overrides its :host rule. The padding stays, so the caption keeps
       its offset from the image. */
    .hide-image-divider image-caption {
      border-top: none;
    }

    .scroll-buttons {
      display: none;
    }

    .scroll-buttons span {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: calc(40rem / var(--default-rem-px-count));
      width: calc(40rem / var(--default-rem-px-count));
      cursor: pointer;
    }

    .scroll-buttons span svg {
      height: calc(16rem / var(--default-rem-px-count));
      width: calc(8rem / var(--default-rem-px-count));
    }

    .left-arrow {
      transform: rotate(180deg);
    }

    .elements-colors {
      background-color: #f8f8f8;
    }

    @media (min-width: 600px) {
      :host {
        --rose-image-height: calc(300rem / var(--default-rem-px-count));
      }

      /* Header/description/scroll-buttons share the standard header row;
         the buttons take the cta slot. */
      .rose-layout.include-header {
        grid-template-areas:
          var(--empty-row)
          var(--text-header-with-cta)
          var(--images-row-with-left-gutter)
          var(--empty-row);
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      /* Top-row texts share a first baseline. */
      .include-header > .header {
        grid-area: header;
        align-self: baseline;
        padding-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .include-header > .description {
        grid-area: description;
        align-self: baseline;
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .include-header > .images {
        grid-area: images;
      }

      .exclude-header > .images {
        grid-column: 2 / 15;
      }

      .scroll-buttons {
        display: flex;
        flex-direction: row;
        justify-content: right;
        align-items: center;
      }

      .include-header > .scroll-buttons {
        grid-area: cta;
      }

      /* Right-aligned inside the top padding row. */
      .exclude-header > .scroll-buttons {
        grid-row: 1;
        grid-column: 12 / 14;
      }

      .images::-webkit-scrollbar-track {
        /*
          This is hard-coded to 34rem for now because it's based on column
          width specifically at the 1200px screen cutoff (32rem + 2rem for the
          outside columns).
        */
        margin-right: calc(34rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      :host {
        --rose-image-height: calc(350rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1200px) {
      :host {
        --rose-image-height: calc(400rem / var(--default-rem-px-count));
      }
    }
  `,
];
